import { BlockMapBuilder, genKey, CharacterMetadata, ContentBlock, convertFromHTML } from 'draft-js';
import toArray from 'lodash/toArray';
import { List, Repeat } from 'immutable';
function compose(...argument) {
    var args = argument;
    var start = args.length - 1;
    return function () {
        var i = start;
        var result = args[start].apply(this, arguments);
        while (i--)
            result = args[i].call(this, result);
        return result;
    };
}
;
/*
 * Helpers
 */
// Prepares img meta data object based on img attributes
const getBlockSpecForElement = (imgElement) => ({
    contentType: 'image',
    src: imgElement.getAttribute('src'),
    width: imgElement.getAttribute('width'),
    height: imgElement.getAttribute('height'),
    align: imgElement.style.cssFloat,
});
// Wraps meta data in HTML element which is 'understandable' by Draft, I used <blockquote />.
const wrapBlockSpec = (blockSpec) => {
    if (blockSpec == null) {
        return null;
    }
    const tempEl = document.createElement('blockquote');
    // stringify meta data and insert it as text content of temp HTML element. We will later extract
    // and parse it.
    tempEl.innerText = JSON.stringify(blockSpec);
    return tempEl;
};
// Replaces <img> element with our temp element
const replaceElement = (oldEl, newEl) => {
    if (!(newEl instanceof HTMLElement)) {
        return;
    }
    const parentNode = oldEl.parentNode;
    return parentNode.replaceChild(newEl, oldEl);
};
const elementToBlockSpecElement = compose(wrapBlockSpec, getBlockSpecForElement);
const imgReplacer = (imgElement) => {
    return replaceElement(imgElement, elementToBlockSpecElement(imgElement));
};
// takes HTML string and returns DraftJS ContentState
export default function customHTML2Content(HTML, contentState) {
    let tempDoc = new DOMParser().parseFromString(HTML, 'text/html');
    // replace all <img /> with <blockquote /> elements
    toArray(tempDoc.querySelectorAll('img')).forEach(imgReplacer);
    // use DraftJS converter to do initial conversion. I don't provide DOMBuilder and
    // blockRenderMap arguments here since it should fall back to its default ones, which are fine
    let { contentBlocks } = convertFromHTML(tempDoc.body.innerHTML);
    // now replace <blockquote /> ContentBlocks with 'atomic' ones
    contentBlocks = contentBlocks.reduce(function (contentBlocks, block) {
        if (block.getType() !== 'blockquote') {
            return contentBlocks.concat(block);
        }
        const image = JSON.parse(block.getText());
        contentState.createEntity('IMAGE-ENTITY', 'IMMUTABLE', image);
        const entityKey = contentState.getLastCreatedEntityKey();
        const charData = CharacterMetadata.create({ entity: entityKey });
        // const blockSpec = Object.assign({ type: 'atomic', text: ' ' }, { entityData })
        const fragmentArray = [
            new ContentBlock({
                key: genKey(),
                type: 'image-block',
                text: ' ',
                characterList: List(Repeat(charData, charData.count())),
            }),
            new ContentBlock({
                key: genKey(),
                type: 'unstyled',
                text: '',
                characterList: List(),
            }),
        ];
        return contentBlocks.concat(fragmentArray);
    }, []);
    // console.log('>> customHTML2Content contentBlocks', contentBlocks);
    return BlockMapBuilder.createFromArray(contentBlocks);
}



// WEBPACK FOOTER //
// ./ext/editor-core/src/EditorCore/customHTML2Content.ts